import $api from 'plugins/api'
import iView from 'iview'
const {dutyChain, cookies} = $api
const status200 = function (type, res = {}) {
  if (type !== 200) return 'next'
  const {config} = res
  const method = config.method.toUpperCase()
  //考虑到浏览器刷新，必须存储到localStorage
  if (method === 'GET') {
    //获取cookie,进行设置
    localStorage.setItem('token', cookies.get('XSRF-TOKEN'))
  }
  if (res.data && res.data.code && res.data.code != '2000') {
    switch (res.data.code) {
      case '10003':
        //重复提交
        res.data.message = '请勿重复提交'
        break
      case '5000':
        //服务端异常
        break
    }
    //阻止错误信息提示
    if (config.preventMessage) {
      return res
    }
    iView.Message.error(res.data.message)
    return Promise.reject(res.data.message)
  }
  return res
}
//创建职责链
const statusDuty = dutyChain(status200)
//定义职责链
export {statusDuty}



// WEBPACK FOOTER //
// ./src/config/interceptors/axios/response-config.js